import { ISlot } from "@nju/data-access-portal-appointment";
import { Arrow } from "../Arrow";
import { Slot } from "./Slot";

export function Slots({
  slots,
  selectedSlot,
  onArrowDown,
  onArrowUp,
  onSlotSelect,
}: {
  slots: ISlot[];
  selectedSlot?: ISlot;
  onArrowDown: () => void;
  onArrowUp: () => void;
  onSlotSelect: (slot: ISlot) => void;
}) {
  const checkIsSelected = (slot: ISlot, selectedSlot?: ISlot) => {
    if (!selectedSlot) {
      return false;
    }
    return !(
      new Date(slot.startDate).getTime() !==
        new Date(selectedSlot?.startDate).getTime() &&
      new Date(slot.endDate).getTime() !==
        new Date(selectedSlot?.endDate).getTime()
    );
  };

  return (
    <div className="w-[120px] flex from-tablet:ml-7 from-tablet:flex-col from-tablet:items-center from-tablet:justify-between only-mobile:inline">
      <Arrow
        className="items-center hidden from-tablet:flex"
        iconName="chevron-up"
        onPress={() => {
          onArrowUp();
        }}
        title="Zaznacz poprzedni przedział czasowy"
      />
      <ul className="flex flex-wrap grow-[2] from-tablet:py-5 from-tablet:flex-col">
        {slots.map((slot, index) => {
          return (
            <Slot
              isSelected={checkIsSelected(slot, selectedSlot)}
              key={index}
              onSlotSelect={onSlotSelect}
              timeSlot={slot}
            />
          );
        })}
      </ul>
      <Arrow
        className="items-center hidden from-tablet:flex"
        iconName="chevron-down"
        onPress={() => {
          onArrowDown();
        }}
        title="Zobacz następne przedział czasowy"
      />
    </div>
  );
}
